import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-white flex items-center justify-center flex-col min-h-screen" }
const _hoisted_2 = { class: "bg-black-body text-center p-20 rounded-xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", {
  class: "block text-6xl",
  style: {"font-size":"130px"}
}, "404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "text-xl my-4" }, "Ops.. Page Not Found", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Back to home ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_router_link, {
        to: "/",
        class: "mt-10 text-white back-to-home text-sm block bg-red-primary p-2 rounded-md hover:bg-blue-700 duration-200 transition-all"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_font_awesome_icon, {
            icon: "fa-solid fa-home",
            class: "mr-2 inline-block"
          }),
          _hoisted_5
        ]),
        _: 1
      })
    ])
  ]))
}